export enum StepperIdEnum {
  COMPONI_SCATOLA = 1,
  RIEMPI_SCATOLA = 2,
  STAMPA_CODICE_PACCO = 3,
  ACCETTA_PACCO = 4,
  RIEPILOGO = 5,
}

export enum StepperLabelEnum {
  COMPONI_SCATOLA = 'Componi scatola',
  RIEMPI_SCATOLA = 'Riempi scatola',
  STAMPA_CODICE_PACCO = 'Stampa codice pacco',
  ACCETTA_PACCO = 'Accetta pacco',
  RIEPILOGO = 'Riepilogo',
}

export enum IdCausalListEnum {
  SATURAZIONE_SCATOLA = 'saturazioneScatola',
  CHIUSURA_STRAORDINARIA = 'chiusuraStraordinaria',
  CHIUSURA_FERIE = 'chiusuraFerie'
}

export enum LabelCausalListEnum {
  SATURAZIONE_SCATOLA = 'Saturazione scatola',
  CHIUSURA_STRAORDINARIA = 'Chiusura straordinaria / necessità',
  CHIUSURA_FERIE = 'Chiusura ferie'
}

export enum IdListaEnum {
  BENI_CONTO_DEPOSITO = '0',
  STORICO = '1',
}

export enum LabelListaEnum {
  BENI_CONTO_DEPOSITO = 'Beni in conto deposito',
  STORICO = 'Storico beni in conto deposito',
}

export enum IdStateEnum {
  TUTTI = '0',
  IN_CONTO_DEPOSITO = '1',
  IN_VERIFICA = '2',
  AFFIDATI = '3',
  SMARRITO = '4',
}

export enum LabelStateEnum {
  TUTTI = 'Tutti',
  IN_CONTO_DEPOSITO = 'In conto deposito',
  IN_VERIFICA = 'In verifica',
  AFFIDATI = 'Affidati',
  SMARRITO = 'Smarrito',
  INVIATO = 'Inviato',
  AFFIDATO = 'Affidato',
  CONTAINERIZZATO = 'Containerizzato',
}

export enum PayloadStateEnum {
  TUTTI = 'Tutti',
  IN_CONTO_DEPOSITO = 'In conto deposito',
  IN_VERIFICA = 'In verifica',
  AFFIDATI = 'Inviati',
  SMARRITO = 'Smarrito',
  INVIATO = 'Inviato',
  AFFIDATO = 'Affidato',
  CONTAINERIZZATO = 'Containerizzato',
}
